import jwt_decode from 'jwt-decode';

type Epoc = number;

export enum TokenLinkType {
  AccountSignUp = 'ACCOUNT_SIGNUP',
  AccountForgot = 'ACCOUNT_FORGOT',
  AccountInvitation = 'ACCOUNT_INVITATION',
  ForgotPassword = 'FORGOT_PASSWORD',
}

export enum PermissionType {
  UserOtp = 'USER:OTP',
}

type ActionType =
  | 'MARK_TODO'
  | 'MARK_IN_PROGRESS'
  | 'MARK_COMPLETED'
  | 'MARK_BLOCKED'
  | 'APPROVE_REQUEST';

type Scope = PermissionType.UserOtp | `TASK:${ActionType}`;

type Decoded = {
  accountId: number;
  emailId: string;
  exp: Epoc;
  iat: Epoc;
  iss: 'rocketlane.com';
  jti: string;
  linkType: TokenLinkType;
  permission: PermissionType;
  scopes: Scope[];
} | null;

const getDecodedValue = (token: string): Decoded => {
  try {
    return jwt_decode<Decoded>(token);
  } catch (e) {
    return null;
  }
};

type TokenMeta = {
  decoded: Decoded;
  isExpired: boolean;
};

export const getTokenMeta = (token: string): TokenMeta => {
  const decoded = getDecodedValue(token);

  const isExpired = decoded
    ? new Date(decoded?.exp * 1000) < new Date()
    : false;

  return { decoded, isExpired };
};
